import { LocalCacheType } from "./types/local";

export const ID_CACHE_KEY = "noliId";
export const NAME_CACHE_KEY = "noliName";
export const GRAPH_CACHE_KEY = "noliGraph";
export const USER_ID_CACHE_KEY = "noliUserId";
export const TRANSFORM_CACHE_KEY = "noliTransform";
export const UPDATE_TIME_CACHE_KEY = "noliUpdateTime";
export const COMMIT_ID_CACHE_KEY = "noliCommitId";
export const PREVIEW_CACHE_KEY = "noliPreview";

export const localCacheKeyMap: Record<keyof LocalCacheType, string> = {
  id: ID_CACHE_KEY,
  name: NAME_CACHE_KEY,
  graph: GRAPH_CACHE_KEY,
  globalTransform: TRANSFORM_CACHE_KEY,
  updateTime: UPDATE_TIME_CACHE_KEY,
  userId: USER_ID_CACHE_KEY,
  commit_id: COMMIT_ID_CACHE_KEY,
  preview: PREVIEW_CACHE_KEY,
};

export const DEFAULT_PROJECT_PREVIEW =
  "http://nolipix-preview.oss-cn-hangzhou.aliyuncs.com/creator/projectSnapshot/defaultPreview.png";
